import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { ElementType } from 'react';
import { ItemWithLabel } from '../utils';
import Button from './Button';

export function ToggleButtons({
  options,
  value,
  onChange,
}: {
  onChange?: (value: any) => void;
  options: ItemWithLabel[];
  value?: any;
}) {
  return (
    <ToggleButtonGroup
      color="standard"
      exclusive
      onChange={(_, val) => onChange?.(val)}
      size="small"
      value={value}
    >
      {options.map((option) => (
        <ToggleButton
          component={Button as ElementType}
          disableElevation
          icon={option.icon}
          key={option.value}
          sx={{ padding: '3px 9px' }}
          value={option.value}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
